<template>
  <div class="tripDetail">
    <ld-header>{{ $t('Details','出差申请单详情') }}</ld-header>
    <div class="wrapper">
      <mescroll-vue
        ref="mescroll"
        :down="down"
      >
        <div class="pad-t-5">
          <van-cell v-if="allData.status != 1 && allData.status != 2 && allData.status != 3">
            {{ allData.status | status }}
          </van-cell>

          <van-field
            label="出差申请单"
            v-model="allData.ccsqdNo"
            readonly
            :border="false"
          />
          <van-field
            :label="$t('K138','申请人')"
            v-model="allData.reqPerson"
            readonly
            :border="false"
          >
            <template #right-icon>
              <ld-icon
                v-if="allData.status == 1"
                class="green fr"
                type="iconweibiaoti-155"
                size="50"
              />
              <ld-icon
                v-if="allData.status == 2"
                class="main-color fr"
                type="iconweibiaoti-25"
                size="50"
              />
              <ld-icon
                v-else-if="allData.status == 3"
                class="red fr"
                type="iconweibiaoti-120"
                size="50"
              />
            </template>
          </van-field>
          <van-field
            :label="$t('K121','申请时间')"
            v-model="allData.reqTime"
            readonly
            :border="false"
          />

          <div class="pad-t-5">
            <van-cell>订单信息</van-cell>
            <van-cell
              :border="false"
              v-show="allData.project==1"
            >
              <van-row>
                <van-col span="6">
                  {{ $t('K106','项目出差') }}
                </van-col>
                <van-col span="18">
                  <span v-show="allData.projectName">（{{ allData.projectName }}&nbsp;{{ allData.projectCode }}）</span>
                </van-col>
              </van-row>
            </van-cell>
            <van-field
              :label="$t('K107','目的地')"
              v-model="allData.mdd"
              readonly
              :border="false"
            />
            <van-field
              :label="$t('K130','出差人')"
              v-model="allData.ccr"
              readonly
              :border="false"
            />
            <van-field
              v-if="allData.sxr"
              :label="$t('K101','同行人员')"
              v-model="allData.sxr"
              readonly
              :border="false"
            />
            <van-field
              :label="$t('K001','成本中心')"
              v-model="allData.costCenterName"
              readonly
              :border="false"
            />
            <!-- costCenterCode -->
            <van-field
              :label="$t('K102','事由')"
              v-model="allData.ccsy"
              readonly
              :border="false"
            />
            <van-field
              :label="$t('K136','出差时间')"
              readonly
              :border="false"
            >
              <template #input>
                {{ allData.dateBegin }} {{ $t('H041','至') }} {{ allData.dateEnd }}
              </template>
            </van-field>
          </div>

          <div class="pad-t-5">
            <van-cell v-show="allRouteList.length > 0">
              {{ $t('K103','行程计划') }}
            </van-cell>
            <div
              v-for="(items,index) in allRouteList"
              :key="index"
            >
              <route
                :show-dele="false"
                :route="items"
              />
            </div>
          </div>

          <!--  费用预算 -->
          <div class="pad-t-5">
            <van-cell>
              {{ $t('E013','费用预算') }}
              <span class="red font12">({{ $t('unit','单位') }}:￥{{ allData.zys }})</span>
            </van-cell>
            <van-row>
              <van-col span="12">
                <van-field
                  label-width="60"
                  :label="$t('E014','交通费')"
                  readonly
                  v-model="allData.jtys"
                />
              </van-col>
              <van-col span="12">
                <van-field
                  label-width="60"
                  :label="$t('E015','住宿费')"
                  readonly
                  v-model="allData.zsys"
                />
              </van-col>
            </van-row>
            <van-row>
              <van-col span="12">
                <van-field
                  label-width="60"
                  :label="$t('E016','其它费用')"
                  readonly
                  v-model="allData.qtys"
                />
              </van-col>
              <van-col span="12">
                <van-field
                  label-width="60"
                  label="总费用"
                  readonly
                  v-model="allData.zys"
                />
              </van-col>
            </van-row>
          </div>

          <!-- 审批规则 -->
          <approval
            v-if="allData.ccsqdNo"
            class="pad-t-5"
            :order-id="orderId"
            :spgz-id="allData.appId"
            :vip-status="allData.status"
            order-type="11099"
            element=".tripDetail"
          />
          <!--  -->
          <van-field
            v-if="allData.remark"
            class="pad-t-5"
            :label="$t('K105','备注说明')"
            readonly
            v-model="allData.remark"
          />
        </div>
      </mescroll-vue>
    </div>

    <!-- 底部导航 -->
    <!--    <ld-tabbar-->
    <!--      ref="tabbar"-->
    <!--      :price-list="priceList"-->
    <!--    >-->
    <!--      <van-row-->
    <!--        class="full-width bg-white shadow pad-lr-10"-->
    <!--        type="flex"-->
    <!--        align="center"-->
    <!--        gutter="8"-->
    <!--        @click="$refs['tabbar'].toggle()"-->
    <!--      >-->
    <!--        <van-col span="23">-->
    <!--          <van-row-->
    <!--            type="flex"-->
    <!--            justify="end"-->
    <!--            gutter="8"-->
    <!--          >-->
    <!--            <van-col-->
    <!--              span="8"-->
    <!--              v-if="allData.status == 1"-->
    <!--            >-->
    <!--              <ld-button-->
    <!--                defaults-->
    <!--                size="md"-->
    <!--                @click.stop="revertApproval(applyItem)"-->
    <!--              >-->
    <!--                {{ $t('B065','撤回') }}-->
    <!--              </ld-button>-->
    <!--            </van-col>-->
    <!--          </van-row>-->
    <!--        </van-col>-->
    <!--      </van-row>-->
    <!--    </ld-tabbar>-->
  </div>
</template>
<script>
import { Cell, Field } from 'vant'
import approval from 'Components/approval/approval'
import MescrollVue from 'mescroll.js/mescroll.vue'
import route from './components/route'
import Business from '@/business/utils/business'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import ldButton from 'Common/ldButton'

export default {
  name: 'DetailsApplications',
  provide: {
    orderType: $dict.ORDER_TYPE.vipCcsqd
  },
  components:{
    [Cell.name]:Cell,
    [Field.name]:Field,
    ldTabbar,
    ldButton,
    approval,
    MescrollVue,
    route
  },
  data: function() {
    return {
      down:{use:false},
      allData: {}, //
      allRouteList: [], //
      status: '', //审批进度
    }
  },
  props:{
    id:{
      type:String,
      default:''
    },
    priceList: {
      type: [Array, Object],
      default: function() {
        return []
      }
    }
  },
  computed:{
    orderId(){
      return this.$route.query.ccsqdId || this.id
    }
  },
  created() {
    this.getSuccessData()
  },
  methods: {
    //获取数据
    getSuccessData() {
      this.$api['common/vipCcsqdGetInfo']({
        ccsqdId: this.orderId
      }).then(resp => {
        this.allData = resp.data||{}
        this.allRouteList = this.allData.allRouteList
        this.allRouteList.forEach(arr => {
          arr.forEach(o => {
            o.spzt = this.allData.status == 2
          })
        })
      })
    },
    async revertApproval () {
      await Business.ApprovalRevert({
        orderId: this.orderId,
        orderType: '11099'
      })
      this.getSuccessData()
    }
  },
  filters:{
    status(val){
      let obj=['草稿','审批中','审批通过','审批拒绝','已删除','报销中','已报销']
      return obj[val]||''
    }
  }
}
</script>
<style lang="less" scoped>

.pad-t-5{
    padding-top: 5px;
}
.wrapper {
    height: calc(100vh - 46px);
    overflow: hidden;
}
</style>

